<template>
  <form-label-group :label="calcLabel" class="mb-2">
    <b-form-textarea
      ref="field"
      :value="value"
      :rows="rows"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      :required="required"
      size="lg"
      @blur="$emit('blur', innerValue)"
      @input="onInput($event)"
    />
  </form-label-group>
</template>

<script>
import FormLabelGroup from '@/components/organisation/FormLabelGroup';

export default {
  name: 'BCustomTextarea',

  components: {
    FormLabelGroup,
  },

  props: ['value', 'label', 'rows', 'placeholder', 'required', 'readonly', 'disabled'],

  data() {
    return {
      innerValue: null,
    };
  },

  computed: {
    calcLabel() {
      return this.label == null ? '' : `${this.label}${this.required ? ' *' : ''}`;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nextValue) {
        this.innerValue = nextValue;
      },
    },
  },

  methods: {
    onInput(value) {
      this.innerValue = value;
      this.$emit('input', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/organisation/BCustomTextarea.vue